import { BaseListStore } from '@monorepo/controlled/src/stores/base-list.store';
import { WebappsCidApi } from '../../../apis/webapps-cid.api';
import { WebappsCidModel } from '../../../models/webapps-cid.model';
import { webappsCidRequestQueue } from '../../../utils/webapps-cid-request-queue';

export class WebappsCidStore {
	listStore = new BaseListStore<WebappsCidModel>({
		listFunc: WebappsCidApi.list,
		model: WebappsCidModel,
	});

	constructor() {
		const originalAbort = this.listStore.abort.bind(this.listStore);
		this.listStore.abort = (reason?: string) => {
			webappsCidRequestQueue.abortCurrent();
			webappsCidRequestQueue.clearPending();
			originalAbort(reason);
		};
	}
}
